﻿// a lot of help from Dan Wahlin: https://weblogs.asp.net/dwahlin/building-an-angularjs-modal-service
import * as Model from "../../../models/models";

export interface ILocationIsoModalService {
    getLocationModal(submission: Model.ISubmission, locationAggregate?: Model.LocationAggregate): angular.IPromise<Model.LocationAggregate>;
}

export class LocationIsoModalService implements ILocationIsoModalService {
    // $uibModal is the angular-ui-bootstrap modal service
    // there is a problem with the typings file for angular-ui-bootstrap that causes the build to break, so we could not include it.  So, $uibModal is declared as 'any'
    static $inject = ['$uibModal'];
    constructor(private $modal: any) { }

    public getLocationModal(submission: Model.ISubmission, locationAggregate?: Model.ILocationAggregate): angular.IPromise<Model.LocationAggregate> {
        const settings: any = {};

        settings.backdrop = "static"; // static means that clicking on the the backdrop will not dismiss the modal, change to true (bool, not string) to enable dismiss on click
        settings.keyboard = true;
        settings.modalFade = true;
        settings.size = "lg";
        settings.templateUrl = "/modules/core/services/locationIsoModalService/locationIsoModal.view.html";
        settings.controller = "locationIsoModalController";
        settings.controllerAs = "vm";
        settings.resolve = {
            data: () => { return {'submission': submission, 'locationAggregate': locationAggregate }; }
        };
        return this.$modal.open(settings).result;
    }
}
